<p-toast></p-toast>
<div *ngIf="isLoading" class="loadingOverlay center-loader">
  <p-progressSpinner [style]="{height: '30px', width: '30px'}" strokeWidth="7" animationDuration="0.5s">
  </p-progressSpinner>
</div>
<!-- <div class="pageInfo">
  <div class="settings-header" style="display: flex;justify-content:space-between; align-items: center; width: 100%;">
      <div style="display: flex;justify-content:space-between; align-items: center;">
          <p style="font-size: var(--fs-large); font-weight: var(--fw-bold);margin-left: 12.5px;">{{activeComponent}}</p>
      </div>
      <button *ngIf="canCreate" style="cursor: pointer;width: 110px" (click)="edit=false;openSideBar()" pButton pRipple type="submit" label="Add New" tabindex="0">
      </button>
  </div>
</div> -->
<div class="info-card">
  <div *ngIf="optionValueList.length > 0; else noOptions" class="info-card-container">
    <div class="option-container text-style" *ngFor="let option of optionValueList">
      <div>{{option.name}}</div>
      <div style="display: flex;gap: 10px;">
        <button *ngIf="canDelete" class="neo-action-item" icon="pi pi-trash" pButton (click)="deleteOptions(option.id, $event)">
        </button>
        <button *ngIf="canUpdate" class="neo-action-item" icon="pi pi-pen-to-square" pButton
          (click)="edit=true;editOption(option)">
        </button>
      </div>
    </div>
  </div>
  <ng-template #noOptions>
    <empty-state *ngIf="!isLoading">
      <empty-state-title>No Options Found</empty-state-title>
      <empty-state-subtitle>Create a option by clicking on "Add New".</empty-state-subtitle>
    </empty-state>
  </ng-template>
</div>

<p-dialog header="Add Option" [(visible)]="addOptionSidebar" [modal]="true" [closable]="true" [draggable]="false"
    [resizable]="false" styleClass="invite-candidate-dialog" (onHide)="addOptionSidebar = false;optionValueForm.reset();">

    <div [formGroup]="optionValueForm" style="width: 40vw;">
      <div class="dialog-content">
        <div class="neo-input-wrapper">
          <label for="name" required>{{activeComponent}}</label>
          <input pInputText type="text" name="name" id="name" formControlName="name">
          <app-handle-error [clicked]="clicked" [control]="optionValueForm.get('name')" [name]="activeComponent"></app-handle-error>
        </div>
        <div *ngIf="this.activeComponent === 'Event Type'" class="neo-input-wrapper">
          <label for="name" required>Institution Type</label>
          <p-select big class="dropdown" inputId="dropdown" [autoDisplayFirst]="false" optionLabel="name" optionValue="value"
              [options]="institution_select_type" formControlName="institution_select_type"
              [required]="true" [style]="{ width: '100%' }"
              [styleClass]="clicked && optionValueForm.controls['institution_select_type'].errors ? 'invalid' : ''">
          </p-select>
          <app-handle-error [clicked]="clicked" [control]="optionValueForm.get('name')" [name]="activeComponent"></app-handle-error>
        </div>
      </div>
      <div class="dialog-action">
         <button pButton pRipple type="submit" [label]="edit ? 'Update' : 'Save'" [style]="{width: '110px'}"
                (click)="edit ? updateOption() : saveOption()" class="create-btn"
                [loading]="saveBtnLoading"></button>
      </div>
    </div>

    @if (false) {
    <div class="addTemplate-header">
        <div class="addTemplate-heading"><em style="margin-right: 12.5px;"
                class="pi"></em>Add Option</div>
        <div class="header-btn">
            <button pButton pRipple type="submit" [label]="edit ? 'Update' : 'Save'" [style]="{width: '110px'}"
                (click)="edit ? updateOption() : saveOption()" class="p-button-raised p-button-text button-align"
                [loading]="saveBtnLoading"></button>
        </div>
    </div>
    <p-divider class="p-divider"></p-divider>
    <div class="templateForm" [formGroup]="optionValueForm">
        <div style="display: flex; align-items: center;">
            <span class="p-float-label templateForm-elements">
                <input class="inputtext" type="text" id="template-title" pInputText formControlName="name"
                    [ngClass]="{'p-filled': optionValueForm.value.name}"
                    [style]="{maxWidth: '32vw !important', width: '400px'}">
                <label for="template-title">{{activeComponent}}</label>
                <app-handle-error [clicked]="clicked" [control]="optionValueForm.get('name')" [name]="activeComponent"></app-handle-error>
            </span>
        </div>
        <div style="display: flex; align-items: center;">
          <span *ngIf="this.activeComponent === 'Event Type'" class="p-float-label templateForm-elements">
            <p-select big class="dropdown" inputId="dropdown" [autoDisplayFirst]="false" optionLabel="name" optionValue="value"
                [options]="institution_select_type" formControlName="institution_select_type"
                [required]="true" [style]="{ maxWidth: '21.5vw' }"
                [styleClass]="clicked && optionValueForm.controls['institution_select_type'].errors ? 'invalid' : ''">
            </p-select>
            <label for="dropdown">Institution Type <span class="imp">*</span></label>
            <app-handle-error [clicked]="clicked" [control]="optionValueForm.get('institution_select_type')" name="Institution Type">
            </app-handle-error>
        </span>
        </div>
    </div>
    }
</p-dialog>
<p-confirmpopup></p-confirmpopup>